module.exports = __webpack_public_path__ + "static/media/company-home-02.11bf787e.png";